/* import __COLOCATED_TEMPLATE__ from './icon-unmute.hbs'; */
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--unmute'],
  width: 32,
  height: 32,
  viewBox: '0 0 32 32'
});